import React from 'react'
import { Box, Grid, Paper, Skeleton, Typography } from '@mui/material'

import { isAnalyzerLoading } from 'Pages/AnalyzersV2/@signals'
import { buildPositionKpis } from 'Pages/AnalyzersV2/@components/PositionKpis/@utils'


export default function PositionKpis({ mainData, currency }) {
	if (isAnalyzerLoading.value) {
		return <Grid container spacing={2}>
			{Array.from({ length: 5 }).map((_, i) =>
				<Grid item xs={12} sm={6} md key={i}>
					<Skeleton variant="rectangular" height={110}/>
				</Grid>)}
		</Grid>
	}

	const kpis = buildPositionKpis(mainData, currency)

	if (!kpis.length) return null

	return <Grid container spacing={2}>
		{kpis.map(({ key, label, value, unit, note, color, noteColor }) =>
			<Grid item xs={12} sm={6} md key={key}>
				<Paper
					variant="outlined"
					sx={{ p: 2, height: '100%', display: 'flex', flexDirection: 'column', gap: 1 }}>
					<Typography
						variant="caption"
						sx={{
							color: 'text.secondary',
							textTransform: 'uppercase',
							letterSpacing: '.05em',
							fontWeight: 'medium'
						}}>
						{label}
					</Typography>

					<Box sx={{ display: 'flex', alignItems: 'baseline', gap: .5 }}>
						<Typography variant="h3" sx={{ fontWeight: 'bold', lineHeight: 1, color }}>
							{value}
						</Typography>
						{!!unit && <Typography variant="subtitle1" sx={{ color: 'text.disabled', fontWeight: 'medium' }}>
							{unit}
						</Typography>}
					</Box>

					<Typography
						variant="caption"
						sx={{ color: noteColor || 'text.secondary', fontWeight: noteColor ? 'bold' : 'regular' }}>
						{note}
					</Typography>
				</Paper>
			</Grid>)}
	</Grid>
}
